import React, { Component, Fragment } from 'react'
import { Button, TableRow, TableCell, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import EditActionComponent from '../common/EditActionComponent'
import moment from 'moment'

import { getCompanyFeatures } from '../../actions/company'
import { connect } from 'react-redux'

class WeedmapPinRow extends Component {
  constructor(props) {
    super(props)
    this.state = { weedmapsEnabled: false }
  }

  componentDidMount() {
    const { weedmapsOrders = {} } = this.props
    if (this.props.version === 2 || this.props.version === 3) {
      const session = JSON.parse(window.localStorage.getItem('session'))
      const isActive = !!weedmapsOrders[session.assignedShop.id]
      this.setState({ weedmapsEnabled: isActive })
    }
  }

  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  onChangeRegion = (event) => {
    const { value } = event.target

    const { regions = [] } = this.props

    let updatedRegion = regions.find((region) => region.id === value)

    this.props.onChange('region', updatedRegion || null)
  }

  onDelete = () => {
    this.props.onDelete(this.props.data)
  }

  renewWeedmapToken = () => {
    const { code = '' } = this.props.data
    this.props.renewWeedmapToken({ code, type: 'REFRESHTOKEN' })
  }

  onChangeEnabled = (dataName, event) => {
    this.props.onChange(dataName, event.target.checked)
  }

  render() {
    const {
      data,
      editMode,
      regions = [],
      version = 1,
      authorizeWeedmapToken = () => {},
    } = this.props

    const maxAuthRetries = 5

    return (
      <TableRow>
        <TableCell className="cell-wrap-word">
          <EditableTextField
            valueToRender={data.name}
            editMode={editMode}
            value={data.name}
            onChange={this.onChange('name')}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </TableCell>
        {version === 2 || version === 3 ? (
          <Fragment>
            {/*<TableCell className="cell-wrap-word">*/}
            {/*<EditableTextField*/}
            {/*valueToRender={data.clientId || ''}*/}
            {/*editMode={editMode}*/}
            {/*value={data.clientId || ''}*/}
            {/*onChange={this.onChange('clientId')}*/}
            {/*type="text"*/}
            {/*/>*/}
            {/*</TableCell>*/}
            {/*<TableCell className="cell-wrap-word">*/}
            {/*<EditableTextField*/}
            {/*valueToRender={data.clientSecret || ''}*/}
            {/*editMode={editMode}*/}
            {/*value={data.clientSecret || ''}*/}
            {/*onChange={this.onChange('clientSecret')}*/}
            {/*type="text"*/}
            {/*/>*/}
            {/*</TableCell>*/}
            {/* <TableCell className="cell-wrap-word">
                        <EditableTextField
                            valueToRender={data.token || ''}
                            editMode={false}
                            value={data.token || ''}
                            onChange={this.onChange('token')}
                            type="text"
                        />
                    </TableCell> */}
            <TableCell className="cell-wrap-word">
              <EditableTextField
                valueToRender={data.listingWmId || ''}
                editMode={editMode}
                value={data.listingWmId || ''}
                onChange={this.onChange('listingWmId')}
                type="text"
              />
            </TableCell>
            {/* <TableCell className="cell-wrap-word">
                        <EditableTextField
                            valueToRender={data.expiresIn && moment(data.expiresIn).format("DD/MM/YYYY")  || ''}
                            editMode={editMode}
                            value={data.expiresIn && moment(data.expiresIn).format("YYYY-MM-DD")  || ''}
                            onChange={this.onChange('expiresIn')}
                            type="date"
                        />
                    </TableCell> */}
          </Fragment>
        ) : null}
        {version === 1 ? (
          <TableCell className="cell-wrap-word">
            <EditableTextField
              valueToRender={data.apiKey}
              editMode={editMode}
              value={data.apiKey}
              onChange={this.onChange('apiKey')}
              type="text"
            />
          </TableCell>
        ) : null}
        {version !== 3 ? (
          <TableCell className="cell-wrap-word">
            <EditableSelect
              value={(data.region && data.region.id) || ''}
              onChange={this.onChangeRegion}
              valueToRender={(data.region && data.region.name) || ''}
              editMode={editMode}
              displayEmpty={true}
            >
              <MenuItem value="">Select Region</MenuItem>
              {regions
                .filter((region) => region.active)
                .map((region) => {
                  return (
                    <MenuItem key={region.id} value={region.id}>
                      {region.name}
                    </MenuItem>
                  )
                })}
            </EditableSelect>
          </TableCell>
        ) : null}

        <Fragment>
          {version === 2 ? (
            <TableCell className="cell-wrap-word">
              {data.status === 'UnAuthorized' ? 'Unauthorized' : data.status}
            </TableCell>
          ) : null}
          <TableCell className="cell-wrap-word">
            {!!data.expiresIn && data.expiresIn && moment(data.expiresIn).isBefore(moment(), 'day')
              ? (
                  <span>
                    {moment(parseInt(data.expiresIn)).format('MM/DD/YYYY')}{' '}
                    <p style={{ color: 'red' }}>(Expired)</p>
                  </span>
                ) || '-'
              : (!!data.expiresIn && moment(parseInt(data.expiresIn)).format('MM/DD/YYYY')) || '-'}
          </TableCell>
        </Fragment>
        <TableCell className="cell-wrap-word">
          <EditableSwitch
            valueToRender={data.enabled ? 'Enabled' : 'Disabled'}
            checked={data.enabled}
            editMode={editMode}
            onChange={(e) => this.onChangeEnabled('enabled', e)}
          />
        </TableCell>

        {version === 2 || version === 3 ? (
          <Fragment>
            <TableCell className="cell-wrap-word">
              <EditableSwitch
                valueToRender={
                  this.state.weedmapsEnabled
                    ? data.enableOnlineOrder
                      ? 'Enabled'
                      : 'Disabled'
                    : 'Unavailable'
                }
                checked={data.enableOnlineOrder}
                editMode={this.state.weedmapsEnabled ? editMode : null}
                onChange={(e) => this.onChangeEnabled('enableOnlineOrder', e)}
              />
            </TableCell>

            <TableCell className="cell-wrap-word">
              <EditableSwitch
                valueToRender={
                  this.state.weedmapsEnabled
                    ? data.enableDeleteOrderFromWm
                      ? 'Enabled'
                      : 'Disabled'
                    : 'Unavailable'
                }
                checked={data.enableDeleteOrderFromWm}
                editMode={this.state.weedmapsEnabled ? editMode : null}
                onChange={(e) => this.onChangeEnabled('enableDeleteOrderFromWm', e)}
              />
            </TableCell>
          </Fragment>
        ) : null}

        {hasAccess() ? (
          <TableCell
            className="cell-wrap-word"
            style={{ minWidth: version === 2 || version === 3 ? 250 : 0 }}
          >
            <div className="">
              {!editMode ? (
                <Fragment>
                  {data.status === 'Authorized' && data.authRetries <= maxAuthRetries ? (
                    <Button className="primary-button margin" onClick={this.renewWeedmapToken}>
                      Renew Token
                    </Button>
                  ) : null}
                  {data.status === 'UnAuthorized' && !data.token ? (
                    <Button className="primary-button margin" onClick={authorizeWeedmapToken}>
                      Authorize Token
                    </Button>
                  ) : null}
                  {data.expiresIn && moment().valueOf() > data.expiresIn ? (
                    <Button className="primary-button margin" onClick={authorizeWeedmapToken}>
                      Re-Authorize Token
                    </Button>
                  ) : null}
                </Fragment>
              ) : null}
              {/* 
                                !data.enabled ?
                                <Button className="primary-button margin" onClick={()=>this.onChangeSync(data,true)}>Enable</Button>:
                                <Button className="primary-button margin" onClick={()=>this.onChangeSync(data,false)}>Disable</Button>
                             */}

              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
              {!editMode ? (
                <Button className="danger-button margin" onClick={this.onDelete}>
                  Delete
                </Button>
              ) : null}
            </div>
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}

export default connect((state) => ({ dispatch: state.dispatch }))(WeedmapPinRow)



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedmapPinItem.js